<template>
  <!--自定义搜索显示-->
  <a-select @change="handleChange" v-model="value">
    <a-select-option value="woker">
      个人
    </a-select-option>
    <a-select-option value="merchant">
      公司
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  syncProps: ['value'],
  props: {
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    field: Object // 当前field对象
  },
  mounted () {
  },
  methods: {
    filterQuery () {
      if (this._value) {
        return this._value
      } else {
        return ''
      }
    },
    handleChange (e) {
      this._value = e
    }
  }
}
</script>

<style lang="less" scoped>
</style>
